export default {
  partialDelivery: {
    required: true
  },
  wayOfDeliveryId: {
    required: true
  }
}